import { FC, useCallback } from "react";
import { Box } from "@mui/material";
import { useDidMount } from "rooks";
import { useFlag } from "@unleash/proxy-client-react";
import { setResourceDetailsActiveTab } from "@/store/resource-details/resourceDetailsSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { resourceDetailsAvailableTabsSelector } from "@/store/resource-details/selectors/options/resourceDetailsAvailableTabsSelector";
import { resourceDetailsResourceCoverageDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataSelector";
import { ResourceDetailsCoverageTabMetadataProgress } from "@/components/pages/common/resource-details/components/content/coverage-content/components/metadata/ResourceDetailsCoverageTabMetadataProgress";
import { getResourceDetailsResourceCoverageDataThunk } from "@/store/resource-details/thunks/coverage-data/getResourceDetailsResourceCoverageDataThunk";
import { KeyValueSplitChip } from "@/components/common/chips/KeyValueSplitChip";

export const ResourceDetailsHeaderCoverageChip: FC = () => {
  const dispatch = useAppDispatch();
  const enableResourceDrawerCoverageDetails = useFlag(
    "EnableResourceDrawerCoverageDetails",
  );

  const data = useAppSelector(resourceDetailsResourceCoverageDataSelector);
  const availableTabs = useAppSelector(resourceDetailsAvailableTabsSelector);

  const viewDetailsHandler = useCallback(() => {
    dispatch(setResourceDetailsActiveTab("coverage"));
  }, [dispatch]);

  const canBeShown =
    enableResourceDrawerCoverageDetails && availableTabs.includes("coverage");
  const disabled = !data?.coverage?.total?.amount;

  useDidMount(() => {
    if (canBeShown) {
      dispatch(getResourceDetailsResourceCoverageDataThunk());
    }
  });

  if (!canBeShown) {
    return null;
  }

  return (
    <KeyValueSplitChip
      title="Coverage"
      value={
        <Box
          width={100}
          onClick={disabled ? undefined : viewDetailsHandler}
          sx={{
            cursor: disabled ? undefined : "pointer",
            color: !disabled ? undefined : "text.disabled",
          }}
        >
          <ResourceDetailsCoverageTabMetadataProgress
            asChip
            total={data?.coverage?.total}
            ri={data?.coverage?.reservation}
            sp={data?.coverage?.savings_plan}
            onDemand={data?.coverage?.on_demand}
          />
        </Box>
      }
    />
  );
};
